import React from 'react'
import moment from 'moment'
import DateTime from 'react-datetime'
import 'moment/locale/cs'
import './DatePicker.scss'

const onChangeHandler = (momentDate, onChange) => {
  onChange({ value: moment.isMoment(momentDate) ? momentDate.toDate() : momentDate })
}

const DatePicker = (props) => {
  const { label, onChange, name, hideTime, value, disabled, required } = props
  const timeFormat = hideTime ? false : 'H:mm'
  const dateFormat = 'D.M.YYYY'
  const alternativeDateFormat = 'DD.MM.YYYY'
  const formats = [`${dateFormat}${timeFormat || ''}`, `${alternativeDateFormat}${timeFormat || ''}`, 'YYYY-MM-DDTHH:mm:ss.sssZ']
  let realValue = ''
  if (value instanceof Date) realValue = value
  else if (moment(value, formats, true).isValid()) realValue = moment(value, formats).toDate()
  else realValue = value
  return (
    <div className="ui input fluid">
      {label ? <strong>{ label }</strong> : ''}
      <DateTime
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        onChange={(data) => onChangeHandler(data, onChange)}
        inputProps={{
          name,
          disabled,
          required,
        }}
        value={realValue}
        placeholder={dateFormat}
      />
    </div>
  )
}

DatePicker.propTypes = {
  label: React.PropTypes.string,
  onChange: React.PropTypes.func.isRequired,
  name: React.PropTypes.string,
  value: React.PropTypes.any,
  hideTime: React.PropTypes.bool,
  disabled: React.PropTypes.bool,
  required: React.PropTypes.bool,
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/browser/components/DatePicker.js